import { render, staticRenderFns } from "./ProReviews.vue?vue&type=template&id=f6f693a2&scoped=true"
import script from "./ProReviews.vue?vue&type=script&lang=js"
export * from "./ProReviews.vue?vue&type=script&lang=js"
import style0 from "./ProReviews.vue?vue&type=style&index=0&id=f6f693a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f693a2",
  null
  
)

export default component.exports